"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupQuickChatListener = void 0;
const models_1 = require("@creature-chess/models");
const state_1 = require("./state");
const setupQuickChatListener = (startListening) => {
    const generations = new Map();
    startListening({
        actionCreator: models_1.playerReceiveQuickChatEvent,
        effect: (_a, api_1) => __awaiter(void 0, [_a, api_1], void 0, function* ({ payload: { sendingPlayerId, chatValue } }, api) {
            var _b;
            if (!chatValue) {
                return;
            }
            const generation = ((_b = generations.get(sendingPlayerId)) !== null && _b !== void 0 ? _b : 0) + 1;
            generations.set(sendingPlayerId, generation);
            api.dispatch(state_1.QuickChatCommands.setPlayerChat({ sendingPlayerId, chatValue }));
            yield api.delay(3000);
            if (generations.get(sendingPlayerId) === generation) {
                api.dispatch(state_1.QuickChatCommands.clearPlayerChat({ sendingPlayerId }));
            }
        }),
    });
};
exports.setupQuickChatListener = setupQuickChatListener;
